<div class="apply-one-style apply-one-grid" [attr.data-e2e]="e2e">
  <div class="site-width py-2">
    <!-- header -->
    <div class="container-fluid">
      <div class="row mb-2 mb-lg-3">
        <div class="col-12 col-lg-6">
          <h1 [attr.data-e2e]="e2e + '-title'">{{ title }}</h1>

          <div [attr.data-e2e]="e2e + '-description'">
            @for (text of description; track text) {
            <p class="standard" [innerHTML]="text"></p>
            }
          </div>

          <div class="d-flex flex-column" [class.flex-column-reverse]="canInstallNativeApp && hasNativeAppLink">
            @if (hasLoginLink) {
            <div [class.mb-2]="!canInstallNativeApp">
              <ecm-mat-seo-login
                [e2e]="e2e + '-login'"
                [style]="buttonLoginStyle"
                [ariaLabel]="buttonLoginAriaLabel"
                [label]="buttonLoginLabel"
                (login)="login.emit()"
                (findIdentifier)="findIdentifier.emit()"
              ></ecm-mat-seo-login>
            </div>
            } @if (hasNativeAppLink && native?.url) {
            <div [class.mb-2]="canInstallNativeApp">
              <ecm-mat-seo-qr-code
                [url]="native.url"
                [canInstallNativeApp]="canInstallNativeApp"
                [e2e]="e2e + '-qr-code'"
              ></ecm-mat-seo-qr-code>
            </div>
            }
          </div>
        </div>

        @if (image) {
        <div class="d-none d-lg-block col-lg-5 offset-lg-1">
          <img [alt]="image.alt" [attr.data-e2e]="e2e + '-image'" [src]="image.url" class="img-fluid ob1-visual" />
        </div>
        }
      </div>
    </div>

    <!-- CTA -->
    @if (withCTA) {
    <div class="container-fluid mb-2">
      <ecm-mat-cta
        [items]="entryPoints"
        (clickCtaLink)="clickCtaButton.emit($event)"
        [e2e]="e2e + '-cta'"
      ></ecm-mat-cta>
    </div>
    }

    <!-- accordions -->
    @if (withAccordions) {
    <div class="container-fluid mb-2">
      <ecm-mat-accordions
        [title]="accordionTitle"
        [items]="accordionItems"
        [e2e]="e2e + '-accordions'"
        (clickAccordionLink)="clickAccordionLink.emit()"
      ></ecm-mat-accordions>
    </div>
    }
    <!-- reasons -->
    @if (withReasons) {
    <div class="bg-dark text-white mb-2">
      <div class="container-fluid py-2">
        <ecm-mat-seo-reasons
          [title]="reasonTitle"
          [subTitle]="reasonSubTitle"
          [items]="reasonItems"
          [caption]="reasonCaption"
          [e2e]="e2e + '-reasons'"
        ></ecm-mat-seo-reasons>
      </div>
    </div>
    }

    <!-- widgets -->
    @if (withWidgets) {
    <div class="container-fluid">
      <ecm-mat-seo-widgets
        [title]="widgetTitle"
        [subTitle]="widgetSubTitle"
        [items]="widgetItems"
        [e2e]="e2e + '-widgets'"
        (clickWidgetButton)="clickWidgetButton.emit($event)"
      ></ecm-mat-seo-widgets>
    </div>
    }
  </div>
</div>
